import { Base } from './Base';

export class Select extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.updateWidth();
    this.handleChange();
  }

  handleChange() {
    this.element.addEventListener('change', () => {
      this.updateWidth();
    });
  }

  updateWidth() {
    const div = document.createElement('div');
    const select = document.createElement('select');
    const option = document.createElement('option');

    div.style.display = 'flex';
    div.style.justifyContent = 'flex-start';
    select.classList.add('select');
    option.innerHTML = this.element.options[this.element.selectedIndex].textContent;

    select.appendChild(option);
    div.appendChild(select);

    document.body.appendChild(div);
    this.element.style.width = select.offsetWidth + 'px';
    document.body.removeChild(div);
  }
}